module.exports = __webpack_public_path__ + "img/ruggero-chef.e7544d03.jpg";